import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TimeFilterPipe } from '@pipes/time-filter/time-filter';
import { SafeHtmlPipe } from '@pipes/safe-html/safe-html';
import { ProfilePriceFilterPipe } from '@pipes/profile-price-filter/profile-price-filter';
import { OrderByPipe } from '@pipes/order-by/order-by';
import { OrderByDatePipe } from '@pipes/order-by-date/order-by-date';
import { DatepickerFilterPipe } from '@pipes/datepicker-filter/datepicker-filter';
import { BoldPipeFilter } from '@pipes/bold/boldPipe';
import { SnDatePickerConfigPipe } from '@pipes/sn-date-picker-config/sn-date-picker.config';
import { CutStringFilterPipe } from '@pipes/cut-string/cut-string';
import { OrderByNamePipe } from '@pipes/order-by/order-by-name';
import { DndAutoScroll } from '@pipes/dnd-autoscroll/dnd-autoscroll';
import { SafePipe } from '@pipes/safe/safe';
import { TimeZoneFilter } from '@pipes/time-zone-filter/time-zone-filter';
import { TableSortPipe } from '@pipes/table-sort/table-sort.pipe';

@NgModule({
	declarations: [
		TimeFilterPipe,
		SafeHtmlPipe,
		ProfilePriceFilterPipe,
		OrderByPipe,
		OrderByDatePipe,
		DatepickerFilterPipe,
		SnDatePickerConfigPipe,
		CutStringFilterPipe,
		BoldPipeFilter,
		OrderByNamePipe,
		DndAutoScroll,
		SafePipe,
		TimeZoneFilter,
		TableSortPipe
	],
	providers: [
		DatePipe,
		ProfilePriceFilterPipe,
		OrderByPipe,
		OrderByDatePipe,
		DatepickerFilterPipe,
		CutStringFilterPipe,
		SnDatePickerConfigPipe,
		BoldPipeFilter,
		OrderByNamePipe,
		DndAutoScroll,
		SafePipe,
		TimeZoneFilter
	],
	exports: [
		TimeFilterPipe,
		SafeHtmlPipe,
		ProfilePriceFilterPipe,
		OrderByPipe,
		OrderByDatePipe,
		DatepickerFilterPipe,
		CutStringFilterPipe,
		SnDatePickerConfigPipe,
		BoldPipeFilter,
		OrderByNamePipe,
		DndAutoScroll,
		SafePipe,
		TimeZoneFilter,
		TableSortPipe
	]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/pipes/pipes.module.ts